import { render, staticRenderFns } from "./StevedoreCost.vue?vue&type=template&id=22a740e3&scoped=true&"
import script from "./StevedoreCost.vue?vue&type=script&lang=js&"
export * from "./StevedoreCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a740e3",
  null
  
)

export default component.exports